<template>
  <el-dialog :append-to-body="appendToBody" :visible.sync="innerVisible" :title="title" width="600px" :close-on-click-modal="false" @close="closeHandler">
    <check-result-display :current-state="currentState" :title="title" />
    <div v-if="showFirstDetails" class="single-wrap">
      <el-scrollbar>
        <check-item-renderer
          v-if="dataSource && dataSource.length > 0 && dataSource[0].details && dataSource[0].details.length > 0"
          :data="convertDataSource(dataSource[0].details)"
        />
      </el-scrollbar>
    </div>
    <div v-else class="check-result-info">
      <el-scrollbar>
        <dl>
          <dt>
            <label>{{ $t('SeaExport.SequenceNumber') }}</label>
            <span>{{ $t('Message.OddNumbers') }}</span>
            <p>{{ $t('Payment.status') }}</p>
          </dt>
        </dl>
        <simple-check-item-renderer v-for="(parent,index) in dataSource" :key="parent.jobNo+index" :index="index+1" :data="parent" #default="{show}" :node="checkNode" :explain-data="explainData">
          <check-item-renderer v-if="parent.details && parent.details.length > 0" v-show="show" :data="convertDataSource(parent.details)" />
        </simple-check-item-renderer>
      </el-scrollbar>
    </div>
    <template v-if="!!remark">
      <el-divider class="margin-bottom-12" />
      <div v-html="remark" />
    </template>
    <span slot="footer">
      <el-button v-show="showOneClickQuery" no="oneClickQuery" type="primary" @click="oneClickQuery">{{ $t('queryJob.OneClickQuery') }}</el-button>
      <el-button v-show="currentState!==states.failure && currentState!==states.checking" no="1" type="primary" @click="continueHandler">{{ btn.confirmText }}</el-button>
      <el-button no="2" type="danger" @click="closeHandler">{{ currentState===states.failure?$t('CargoMsg.Cargo_Close'):$t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ErrorTip from '@/utils/class/ErrorTip'
import CheckResultDisplay from './CheckResultDisplay'
import CheckItemRenderer from './CheckItemRenderer'
import SimpleCheckItemRenderer from './SimpleCheckItemRenderer'
import {
  checkChargeByInvoiceSaveNode,
  checkChargeByBillPaymentSaveNode,
  checkExplainByJobs,
  checking,
  checkingWithNewData, checkChargeByBillingSaveNode
} from '@/api/booking/job'
import { matchView, refreshView } from '@/store/modules/tagsView'

const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure',
  partialPass: 'partialPass'
}
import BatchCheckingWindowHP from './BatchCheckingWindowHP'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { cache, cacheName } from '@/utils/cacheManager'
export default {
  name: 'BatchCheckingWindow',
  components: { CheckResultDisplay, SimpleCheckItemRenderer, CheckItemRenderer },
  props: {
    visible: { type: Boolean, required: true },
    // When enabled, auto-close the dialog as soon as validation passes (state=success).
    // Warnings/failures (or partialPass) still require manual user confirmation/close.
    autoCloseOnSuccess: { type: Boolean, default: true },
    checkNode: { type: Number, required: true },
    lob: { type: String, required: true },
    jobs: { type: Array, required: true },
    allowPartialCheckPass: { type: Boolean, required: false, default: false }, // 是否允许部分检查通过
    callBack: { type: Function, default: null },
    callBack2: { type: Function, default: null },
    closeCallback: { type: Function, default: null },
    batchCreateJob: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false },
    newJob: { type: Object, default: null },
    resData: { type: Object, default: null },
    billPayments: { type: Object, default: null }
  },
  data() {
    return {
      isHc: false,
      states,
      innerVisible: this.visible,
      batchCheckingWindowHP: new BatchCheckingWindowHP(this),
      currentState: states.checking,
      title: '',
      showCheckResultDisplay: false,
      dataSource: [],
      loadings: [], // 待放
      hasPassKey: false, // 是否有验证通过或警告的记录
      cursor: 0, // 游标
      finalState: '', // 最终结果
      remark: '',
      returnValue: false, // 方法回调返回值
      btn: {
        confirmText: this.$t('CargoMsg.Cargo_ConfirmR'),
        showConfirmButton: false,
        showCloseButton: false
      },
      failJobs: [],
      showOneClickQuery: false,
      explainData: {} // 用于node为24，25，26，27的节点使用
    }
  },
  errorCaptured(err) { // // todo-shengsheng  Desc: 异步异常测试
    if (err instanceof ErrorTip) {
      this.$message(err)
      return false
    }
    return true
  },
  computed: {
    showFirstDetails() {
      return this.isHc && this.checkNode === CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code
    },
    currentUserId() {
      return this.$store.getters.userInfo.userId
    },
    checkPassKeys() { // 获取部分检查通过记录keys
      const keys = []
      for (const item of this.loadings) {
        if (item['state'] === 'success' || item['state'] === 'warning') {
          keys.push(item['key'])
        }
      }
      this.$logger.log('checkPassKeys——keys：', keys)
      return keys
      // return keys.join(',')
    }
  },
  watch: {
    currentState: {
      handler(val) {
        if (val === this.states.success || val === this.states.partialPass) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_ConfirmR')
        } else if (val === this.states.warning) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_GoOn')
        }
      },
      immediate: true
    },
    visible: {
      handler(val) {
        this.innerVisible = val
        if (this.isDebugEnabled()) {
          // eslint-disable-next-line no-console
          console.log(`[BatchCheckingWindow][debug] visible changed: visible=${val} checkNode=${this.checkNode} jobs=${(this.jobs && this.jobs.length) || 0} autoCloseOnSuccess=${this.autoCloseOnSuccess}`)
        }
        if (val) {
          this.addedToStageHandler()
        } else {
          this.dataSource = []
        }
      },
      immediate: true
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
  },
  methods: {
    isDebugEnabled() {
      // Temporary: always-on debug logs to locate why auto-close doesn't trigger.
      // TODO: remove after issue is confirmed.
      return true
    },
    /**
     * 开始验证
     */
    async startCheck() {
      if (this.checkNode === CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code) {
        await this.checkingByBillPayment()
        this.currentState = this.finalState
      } else if (this.checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code || this.checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code) {
        // 外部已经获取了节点从，此处直接拼接即可
        this.checkingResultHandlerByBillPaymentNode(this.resData || [])
        this.currentState = this.finalState
      } else if (this.checkNode === CheckRuleConstants.NODE_SAVE_BILLING.code) {
        // 外部已经获取了节点从，此处直接拼接即可
        await this.checkingByBillingSave()
        this.currentState = this.finalState
      } else {
        if (this.cursor <= this.loadings.length - 1) { // todo 搞个并发Promise 优化
          await this.checking(this.loadings[this.cursor++])
        } else {
          this.currentState = this.finalState
        }
      }
      //
      if (this.currentState === 'failure' && this.allowPartialCheckPass && this.hasPassKey) {
        this.currentState = 'partialPass'
      }
    },
    async checkingByBillPayment() {
      const data = {}
      data.checkNode = this.checkNode
      data.chargeUuidList = this.jobs.map(item => item.chargeUuid)
      data.branchId = this.$store.getters.currentOfficeId
      data.billPayments = this.billPayments || []
      await checkChargeByBillPaymentSaveNode(data).then(res => {
        this.checkingResultHandlerByBillPaymentNode(res.data)
      }).catch(() => {
        this.faultHandler()
      })
    },
    async checkingByBillingSave() {
      const data = {}
      data.checkNode = this.checkNode
      data.chargeUuidList = this.jobs.map(item => item.chargeUuid)
      data.branchId = this.$store.getters.currentOfficeId
      data.billing = this.billing || []
      await checkChargeByBillingSaveNode(data).then(res => {
        this.checkingResultHandlerByBillPaymentNode(res.data)
      }).catch(() => {
        this.faultHandler()
      })
    },
    /**
     * 验证
     */
    async checking(item) {
      item['state'] = 'checking'
      // setTimeout(function() {
      // 根据 job获取的 校验结果详情集合
      // const results = [
      //   { ruleName: 'ruleName', checkMode: 'checkMode', checkCategory: 'checkCategory',
      //     expressions: [{ checkItem: 'checkItem', checkValue: 'checkValue', operator: 'operator', match: true }, { checkItem: 'checkItem', checkValue: 'checkValue', operator: 'operator', match: true }]
      //   }]
      if (this.checkNode === 11) {
        // Job.checkingSave(checkNode, item["job"], checkingResultHandler, checkFaultHandler); 【看后台方法觉得checkingSave 和 checking没什么区别，现合二为一】
        if (this.newJob) {
          await checkingWithNewData(this.checkNode, item['job'].uuid, item['job'].lob, this.newJob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        } else {
          await checking(this.checkNode, item['job'].uuid, item['job'].lob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        }
      } else if (this.checkNode === CheckRuleConstants.NODE_RELEASE_ORDER_REVIEW_DELEGATION.code) {
        const bodyList = {
          requestReleaseState: item['job'].requestReleaseState,
          docType: item['job'].docType,
          jobNo: item['job'].jobNo
        }
        await checkAnyContent(bodyList, CheckRuleConstants.NODE_RELEASE_ORDER_REVIEW_DELEGATION.code).then(res => {
          this.checkingResultHandler(res.data || [])
        }).catch(() => {
          this.faultHandler()
        })
      } else {
        // Job.checking(checkNode, item["key"], checkingResultHandler, checkFaultHandler);
        const lob = this.jobs && this.jobs.length > 0 ? this.jobs[0].lob : this.lob
        if (!lob || lob === 'all') {
          this.$message.warning(this.$t('Message.PleaseTheSameBusinessOperate'))
          return
        }
        // 批量创建业务的校验，无key
        if (this.batchCreateJob) {
          await this.checkingResultHandler(item.job.checkingResult || [])
        } else if (this.newJob) {
          await checkingWithNewData(this.checkNode, item['key'], item['job'].lob, this.newJob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        } else {
          await checking(this.checkNode, item['key'], item['job'].lob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        }
      }
      // }, 300)
      if (item['state'] === states.failure || item['state'] === states.warning) {
        this.failJobs.push(item['job'])
      }
    },

    /**
 * @private
 */
    async checkingResultHandler(details) {
      const item = this.loadings[this.cursor - 1]
      item['state'] = 'success'
      item['details'] = details
      let hasWarning = false
      let hasFailure = false
      for (const checkRule of details) {
        // CARGO-2064，有树校验时，当明细中先出现警告，那该票就是[警告]，而没管后面明细是否有[错误]了
        if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_WARNING.code) {
          hasWarning = true
        } else if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_ERROR.code) {
          hasFailure = true
        }
      }
      if (hasFailure) {
        this.finalState = item['state'] = 'failure'
      } else {
        if (hasWarning) {
          item['state'] = 'warning'
          if (this.finalState === 'success') { this.finalState = 'warning' }
        }
      }
      //
      if (item['state'] === 'success' || item['state'] === 'warning') {
        this.hasPassKey = true
      }
      await this.startCheck()
    },
    async checkingResultHandlerByBillPaymentNode(checkMap) {
      // 根据返回的数据在
      for (const item of this.loadings) {
        const details = checkMap[item['key']]
        if (details) {
          item['state'] = 'success'
          item['details'] = details
          let hasWarning = false
          let hasFailure = false
          for (const checkRule of details) {
            // CARGO-2064，有树校验时，当明细中先出现警告，那该票就是[警告]，而没管后面明细是否有[错误]了
            if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_WARNING.code) {
              hasWarning = true
            } else if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_ERROR.code) {
              hasFailure = true
            }
          }
          if (hasFailure) {
            this.finalState = item['state'] = 'failure'
          } else {
            if (hasWarning) {
              item['state'] = 'warning'
              if (this.finalState === 'success') {
                this.finalState = 'warning'
              }
            }
          }
          //
          if (item['state'] === 'success' || item['state'] === 'warning') {
            this.hasPassKey = true
          }
        }
      }
    },
    checkFaultHandler(event) {
      this.startCheck()
      this.$message.error(this.$t('Message.OperationError'))
    },
    async addedToStageHandler(event) {
      const node = CommonState.getStateByCode(CheckRuleConstants.CHECK_NODES, this.checkNode)
      this.title = this.$store.getters.language === 'zh' ? node.chineseName : node.englishName
      const dataSource = []
      this.loadings = []
      this.currentState = 'checking'
      this.failJobs = []

      this.remark = ''
      if (CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode]) {
        this.remark = CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode]
      }
      for (const job of [...this.jobs]) {
        const item = {}
        item['type'] = 'parent'
        item['open'] = false
        item['jobNo'] = (job.jobNo === null || job.jobNo === '') ? this.$t('queryJob.AddNewBusiness') : job.jobNo
        item['key'] = (this.checkNode === CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code || this.checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code || this.checkNode === CheckRuleConstants.NODE_SAVE_BILLING.code || this.checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code) ? job.jobUuid : job.uuid
        item['state'] = 'stay'
        item['job'] = job
        item['index'] = dataSource.length
        if (this.checkNode === CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code || this.checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code || this.checkNode === CheckRuleConstants.NODE_SAVE_BILLING.code || this.checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code) {
          if (!dataSource.find(v => v.jobNo === item['jobNo'])) {
            dataSource.push(item)
            item['index'] = dataSource.length
            this.loadings.push(item)
          }
        } else {
          dataSource.push(item)
          item['index'] = dataSource.length
          this.loadings.push(item)
        }
      }
      this.hasPassKey = false
      this.finalState = 'success'
      if (this.loadings.length > 0) {
        this.cursor = 0
        await this.startCheck()
      } else {
        this.currentState = 'success'
      }
      console.log('===dataSource', dataSource)
      this.dataSource = dataSource
      this.showOneClickQuery = this.failJobs.length > 0 && (this.checkNode === CheckRuleConstants.NODE_PRE_COMMIT.code || this.checkNode === CheckRuleConstants.NODE_COMMIT.code ||
        this.checkNode === CheckRuleConstants.NODE_FINANCIAL_AUDIT.code)
      if (this.showOneClickQuery) {
        if (this.checkNode === CheckRuleConstants.NODE_PRE_COMMIT.code) {
          this.remark += (this.remark ? '<br>' : '') + this.$t('queryJob.PreSubimtCheckTip')
        } else if (this.checkNode === CheckRuleConstants.NODE_COMMIT.code) {
          this.remark += (this.remark ? '<br>' : '') + this.$t('queryJob.SubimtCheckTip')
        } else if (this.checkNode === CheckRuleConstants.NODE_FINANCIAL_AUDIT.code) {
          this.remark += (this.remark ? '<br>' : '') + this.$t('queryJob.FinanceAuditCheckTip')
        }
      }

      // 如果节点为Ar、Ap的确认和复核 调用接口拿到对应的gpExplain和说明
      if (this.checkNode === CheckRuleConstants.NODE_AR_SURE.code ||
        this.checkNode === CheckRuleConstants.NODE_AP_SURE.code ||
        this.checkNode === CheckRuleConstants.NODE_AR_RECHECK.code ||
        this.checkNode === CheckRuleConstants.NODE_AP_RECHECK.code) {
        if (this.jobs && this.jobs.length > 0) {
          // 组装数据
          const data = this.jobs.map(item => {
            return {
              jobUuid: item.uuid,
              lob: item.lob
            }
          })

          const result = await checkExplainByJobs(data).catch(() => {})
          if (result && result.data) {
            this.explainData = result.data
          }
        }
      }

      // Treat "warning" as passable too (user can continue), so auto-close on success OR warning.
      // Do NOT auto-close on partialPass, because it implies some jobs failed and user may need awareness.
      if (this.isDebugEnabled()) {
        // eslint-disable-next-line no-console
        console.log(`[BatchCheckingWindow][debug] check finished: checkNode=${this.checkNode} currentState=${this.currentState} finalState=${this.finalState} innerVisible=${this.innerVisible} autoCloseOnSuccess=${this.autoCloseOnSuccess} allowPartialCheckPass=${this.allowPartialCheckPass} hasPassKey=${this.hasPassKey}`)
      }
      if (this.autoCloseOnSuccess && (this.currentState === this.states.success || this.currentState === this.states.warning) && this.innerVisible) {
        const msgType = this.currentState === this.states.success ? 'success' : 'warning'
        this.$message[msgType](this.$t('Message.N0VerificationPassed', [this.title]))
        if (this.isDebugEnabled()) {
          // eslint-disable-next-line no-console
          console.log('[BatchCheckingWindow][debug] auto-close triggered -> continueHandler()')
        }
        this.continueHandler()
      }
    },

    /**
     * @private
     */
    continueHandler() {
      if (this.callBack != null) {
        this.returnValue = this.callBack()
        if (this.returnValue) {
          this.$emit('returnCallBack', this.returnValue)
        }
      }
      this.toCloseDialog()
    },
    // 转换（清洗） 详情child的数据结构
    convertDataSource(details) {
      const nodes = []
      if (!details) return nodes
      for (const checkRule of details) {
        const node = {}
        node['type'] = 'node'
        node['name'] = checkRule['ruleName']
        node['checkMode'] = checkRule['checkMode']
        node['checkCategory'] = checkRule['checkCategory']
        nodes.push(node)

        for (var item of checkRule['expressions']) {
          const obj = {}
          obj['type'] = 'item'
          obj['name'] = item['checkItem']
          obj['value'] = item['checkValue']
          obj['operator'] = item['operator']
          obj['match'] = item['match']
          obj['customDescription'] = item['customDescription']
          obj['checking'] = false
          obj['node'] = node
          nodes.push(obj)
        }
      }
      return nodes
    },
    closeHandler() {
      if (this.closeCallback) {
        this.closeCallback()
      }
      this.toCloseDialog()
    },
    faultHandler() {
      this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
    },
    toCloseDialog() {
      // 验证规则验证业务之后需要更新业务
      this.$emit('closeCallback')
      this.$emit('update:visible', false)
    },
    oneClickQuery() {
      if (this.checkNode === CheckRuleConstants.NODE_PRE_COMMIT.code || this.checkNode === CheckRuleConstants.NODE_COMMIT.code) {
        const lob = this.failJobs[0].lob
        const jobNos = Array.from(this.failJobs, p => p.jobNo)
        const oldRoute = this.$route
        const params = this.jumpBusinessModule(lob, jobNos)
        setTimeout(() => {
          // 路由无变化，手动刷新
          if (this.$route === oldRoute) {
            const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
            for (const key in view.params) {
              delete view.params[key]
            }
            Object.assign(view.params, params)
            refreshView(view)
          }
        }, 100)
      } else if (this.checkNode === CheckRuleConstants.NODE_FINANCIAL_AUDIT.code) {
        const lobJobNosMap = new Map()
        for (const job of this.failJobs) {
          const jobNos = lobJobNosMap.get(job.lob)
          if (jobNos) {
            jobNos.push(job.jobNo)
          } else {
            lobJobNosMap.set(job.lob, [job.jobNo])
          }
        }
        let isFirst = true
        for (const [lob, jobNos] of lobJobNosMap) {
          if (isFirst) {
            this.jumpBusinessModule(lob, jobNos)
            isFirst = false
          } else {
            setTimeout(() => {
              this.jumpBusinessModule(lob, jobNos)
            }, 100)
          }
        }
      }
      this.closeHandler()
    },
    jumpBusinessModule(lob, jobNos) {
      const conditions = [{ fieldName: 'job.JOB_NO', operator: 'BATCH', value: jobNos }]
      switch (lob) {
        case 'SE':
          this.$router.push({ name: 'SeaBooking', params: { conditions }})
          break
        case 'SI':
          this.$router.push({ name: 'SiBooking', params: { conditions }})
          break
        case 'AE':
          this.$router.push({ name: 'AeBooking', params: { conditions }})
          break
        case 'AI':
          this.$router.push({ name: 'AiBooking', params: { conditions }})
          break
        case 'RE':
        case 'RI':
          this.$router.push({ name: 'ReBooking', params: { conditions }})
          break
        case 'IE':
          this.$router.push({ name: 'IEBooking', params: { conditions }})
          break
      }
      return { conditions }
    }
  }
}
</script>

<style lang="scss" scoped>
.check-result-info{
  min-height: 200px;
  border: 1px solid #E9EBEF;
  .el-scrollbar{
    height: 300px;
    /deep/ .el-scrollbar__wrap{
      overflow-x: hidden;
    }
    /deep/ .is-vertical{
        opacity: 1;
      .el-scrollbar__thumb{
        background-color: rgba(153, 153, 153, 0.8);
      }
    }
  }
  dl{
    margin: 0;
    dt{
      background-color: #EAEEF5;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #000;
      label{
        width: 10%;
      }
      span{
        width: 60%;
      }
      p{
        width: 30%;
      }
    }
  }
}
.margin-bottom-12 {
  margin-bottom: 12px;
}
</style>
<style>
  .batch-checking-window .el-dialog__body{
    padding: 0px 10px!important;
  }
</style>
